import { isObjectRecord } from "../../typeGuards";
import { ArsTableCellType, ArsTableColumnOperationCell } from "../interface";
import { isArsTableCellBase } from "./isArsTableCellBase";

/**
 * Type guard for ArsTableColumnOperationCell, which is a possible type of ArsTableCellBase.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cell's displayContent and annotationContent
 * @returns - True if the object is an ArsTableColumnOperationCell, false otherwise
 */
export const isArsTableColumnOperationCell = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableColumnOperationCell<T> => {
  if (!isObjectRecord(obj)) return false;
  if (!isArsTableCellBase<T>(obj, isT)) return false;

  if (obj.cellType !== ArsTableCellType.ColumnOperation) return false;
  if (!["number", "undefined"].includes(typeof obj.decimalAlignPercentage)) return false;
  if (!["boolean", "undefined"].includes(typeof obj.hidden)) return false;
  if (typeof obj.targetId !== "string") return false;
  if (obj.targetType !== "operation") return false;
  if (!["number", "undefined"].includes(typeof obj.width)) return false;

  // Everything is good
  return true;
};
